import { createContext, useContext } from "react";

export interface GlobalContextType {
  headerColor: string | false;
  changeHeaderColor: (value: string) => void;
}

const GlobalContextValues: GlobalContextType = {
  headerColor: "black",
  changeHeaderColor: () => {},
};

export const GlobalContext =
  createContext<GlobalContextType>(GlobalContextValues);
export const useGlobalContext = () => useContext(GlobalContext);
